export default __webpack_public_path__ + "static/media/instagram-logo.a1950cc4.png";